module.exports = __webpack_public_path__ + "img/TrolleSuchen.710a8301.jpg";